import _ from 'lodash';

import {
  createFetchActionForNamespace,
  createPostActionForNamespace,
  createReducer,
  createFetchReducers,
  createFetchSelectors
} from 'utils/reducers';

const createFetchAction = createFetchActionForNamespace('frontDesk');
const createPostAction = createPostActionForNamespace('frontDesk');

export const fetchRoomMoves = createFetchAction({
  name: 'FETCH_ROOM_MOVES',
  initialAction: ({locationRef, option, dateFrom, dateTo}, extraActions) => ({
    payload: {
      locationRef,
      option,
      dateFrom,
      dateTo,
      extraActions
    }
  }),
  stateKey: 'roomMoves',
  defaultStateValue: []
});
const roomMovesSelector = createFetchSelectors(fetchRoomMoves);
export const selectRoomMoves = roomMovesSelector.data;
export const selectRoomMovesLoading = roomMovesSelector.isLoading;

export const fetchCompletedRoomMoves = createFetchAction({
  name: 'FETCH_COMPLETED_ROOM_MOVES',
  initialAction: ({locationRef, option}, extraActions) => ({
    payload: {
      locationRef,
      option,
      completed: true,
      extraActions
    }
  }),
  stateKey: 'completedRoomMoves',
  defaultStateValue: []
});
const completedRoomMovesSelector = createFetchSelectors(
  fetchCompletedRoomMoves
);
export const selectCompletedRoomMoves = completedRoomMovesSelector.data;
export const selectCompletedRoomMovesLoading =
  completedRoomMovesSelector.isLoading;

export const fetchPendingRenewals = createFetchAction({
  name: 'FETCH_PENDING_RENEWALS',
  initialAction: ({locationRef, option, dateFrom, dateTo}) => ({
    payload: {
      locationRef,
      option,
      dateFrom,
      dateTo
    }
  }),
  stateKey: 'pendingRenewals',
  defaultStateValue: []
});
const pendingRenewalsSelector = createFetchSelectors(fetchPendingRenewals);
export const selectPendingRenewals = pendingRenewalsSelector.data;
export const selectPendingRenewalsLoading = pendingRenewalsSelector.isLoading;

export const fetchCompletedRenewals = createFetchAction({
  name: 'FETCH_COMPLETED_RENEWALS',
  initialAction: ({locationRef, option}) => ({
    payload: {
      locationRef,
      option
    }
  }),
  stateKey: 'completedRenewals',
  defaultStateValue: []
});
const completedRenewalsSelector = createFetchSelectors(fetchCompletedRenewals);
export const selectCompletedRenewals = completedRenewalsSelector.data;
export const selectCompletedRenewalsLoading =
  completedRenewalsSelector.isLoading;

export const fetchArrivals = createFetchAction({
  name: 'FETCH_ARRIVALS',
  initialAction: ({locationRef, option, dateFrom, dateTo}, extraActions) => ({
    payload: {
      locationRef,
      option,
      dateFrom,
      dateTo,
      extraActions
    }
  }),
  stateKey: 'arrivals',
  defaultStateValue: []
});
const arrivalsSelector = createFetchSelectors(fetchArrivals);
export const selectArrivals = arrivalsSelector.data;
export const selectArrivalsLoading = arrivalsSelector.isLoading;

export const fetchCheckedInTodayArrivals = createFetchAction({
  name: 'FETCH_CHECKED_IN_TODAY_ARRIVALS',
  initialAction: ({locationRef}, extraActions) => ({
    payload: {
      locationRef,
      extraActions
    }
  }),
  stateKey: 'checkedInTodayArrivals',
  defaultStateValue: []
});
const checkedInTodayArrivalsSelector = createFetchSelectors(
  fetchCheckedInTodayArrivals
);
export const selectCheckedInTodayArrivals = checkedInTodayArrivalsSelector.data;
export const selectCheckedInTodayArrivalsLoading =
  checkedInTodayArrivalsSelector.isLoading;

export const fetchDepartures = createFetchAction({
  name: 'FETCH_DEPARTURES',
  initialAction: ({locationRef, option, dateFrom, dateTo}, extraActions) => ({
    payload: {
      locationRef,
      option,
      dateFrom,
      dateTo,
      extraActions
    }
  }),
  stateKey: 'departures',
  defaultStateValue: []
});
const departuresSelector = createFetchSelectors(fetchDepartures);
export const selectDepartures = departuresSelector.data;
export const selectDeparturesLoading = departuresSelector.isLoading;

export const fetchCheckedOutTodayDepartures = createFetchAction({
  name: 'FETCH_CHECKED_OUT_TODAY_DEPARTURES',
  initialAction: ({locationRef}, extraActions) => ({
    payload: {
      locationRef,
      extraActions
    }
  }),
  stateKey: 'checkedOutTodayDepartures',
  defaultStateValue: []
});
const checkedOutTodayDeparturesSelector = createFetchSelectors(
  fetchCheckedOutTodayDepartures
);
export const selectCheckedOutTodayDepartures =
  checkedOutTodayDeparturesSelector.data;
export const selectCheckedOutTodayDeparturesLoading =
  checkedOutTodayDeparturesSelector.isLoading;

export const fetchRoomMove = createFetchAction({
  name: 'FETCH_ROOM_MOVE',
  initialAction: ({locationRef, roomMoveId}, extraActions = []) => ({
    payload: {
      roomMoveId,
      locationRef,
      extraActions
    }
  })
});
const roomMoveSelector = createFetchSelectors(fetchRoomMove);
export const selectRoomMove = roomMoveSelector.data;

export const fetchMemberCheckInInfo = createFetchAction({
  name: 'FETCH_MEMBER_CHECK_IN_INFO',
  initialAction: ({locationRef, bookingId}, extraActions = []) => ({
    payload: {locationRef, bookingId, extraActions}
  })
});

export const fetchMemberCheckOutInfo = createFetchAction({
  name: 'FETCH_MEMBER_CHECK_OUT_INFO',
  initialAction: ({locationRef, bookingId}, extraActions = []) => ({
    payload: {locationRef, bookingId, extraActions}
  })
});

export const fetchRenewBookingInfo = createFetchAction({
  name: 'FETCH_RENEW_BOOKING_INFO',
  initialAction: ({locationRef, bookingId}, extraActions = []) => ({
    payload: {locationRef, bookingId, extraActions}
  })
});

export const checkInTenants = createPostAction({
  name: 'CHECK_IN_TENANTS',
  initialAction: ({tenancyId}, extraActions = []) => ({
    payload: {tenancyId, extraActions}
  })
});

export const undoCheckInTenants = createPostAction({
  name: 'UNDO_CHECK_IN_TENANTS',
  initialAction: ({bookingId}, extraActions = []) => ({
    payload: {bookingId, extraActions}
  })
});

export const undoCheckOutTenants = createPostAction({
  name: 'UNDO_CHECK_OUT_TENANTS',
  initialAction: ({bookingId}, extraActions = []) => ({
    payload: {bookingId, extraActions}
  })
});

export const checkOutTenants = createPostAction({
  name: 'CHECK_OUT_TENANTS',
  initialAction: ({tenancyId}, extraActions = []) => ({
    payload: {tenancyId, extraActions}
  })
});

export const roomInspectionPass = createPostAction({
  name: 'ROOM_INSPECTION_PASS',
  initialAction: (
    {bookingId, locationRef, allocationId},
    extraActions = []
  ) => ({
    payload: {bookingId, locationRef, allocationId, extraActions}
  }),
  formName: 'roomInspectionPass'
});

export const roomInspectionRemove = createPostAction({
  name: 'ROOM_INSPECTION_REMOVE',
  initialAction: (
    {bookingId, locationRef, allocationId},
    extraActions = []
  ) => ({
    payload: {bookingId, locationRef, allocationId, extraActions}
  }),
  formName: 'roomInspectionRemove'
});

export const completeRoomMove = createPostAction({
  name: 'COMPLETE_ROOM_MOVE',
  initialAction: (
    {locationRef, roomMoveId},
    successExtraActions = [],
    failureExtraActions = []
  ) => ({
    payload: {
      locationRef,
      roomMoveId,
      successExtraActions,
      failureExtraActions
    }
  })
});

export const undoCompleteRoomMove = createPostAction({
  name: 'UNDO_COMPLETE_ROOM_MOVE',
  initialAction: (
    {locationRef, roomMoveId},
    successExtraActions = [],
    failureExtraActions = []
  ) => ({
    payload: {
      locationRef,
      roomMoveId,
      successExtraActions,
      failureExtraActions
    }
  })
});

export const renewBooking = createPostAction({
  name: 'RENEW_BOOKING',
  initialAction: (
    {locationRef, oldBooking, newBooking},
    extraActions = []
  ) => ({
    payload: {locationRef, oldBooking, newBooking, extraActions}
  })
});

export const undoRenewBooking = createPostAction({
  name: 'UNDO_RENEW_BOOKING',
  initialAction: (
    {locationRef, oldBooking, newBooking},
    extraActions = []
  ) => ({
    payload: {locationRef, oldBooking, newBooking, extraActions}
  })
});

export const giveAccessToRoom = createPostAction({
  name: 'GIVE_ACCESS_TO_ROOM',
  initialAction: ({locationRef, roomMoveId}, extraActions = []) => ({
    payload: {locationRef, roomMoveId, extraActions}
  })
});

export const undoGiveAccessToRoom = createPostAction({
  name: 'UNDO_GIVE_ACCESS_TO_ROOM',
  initialAction: ({locationRef, roomMoveId}, extraActions = []) => ({
    payload: {locationRef, roomMoveId, extraActions}
  })
});

export const vacateRoom = createPostAction({
  name: 'VACATE_ROOM',
  initialAction: ({locationRef, roomMoveId}, extraActions = []) => ({
    payload: {locationRef, roomMoveId, extraActions}
  })
});

export const undoVacateRoom = createPostAction({
  name: 'UNDO_VACATE_ROOM',
  initialAction: ({locationRef, roomMoveId}, extraActions = []) => ({
    payload: {locationRef, roomMoveId, extraActions}
  })
});

export const fetchPaymentSummary = createFetchAction({
  name: 'FETCH_PAYMENT_SUMMARY',
  initialAction: ({locationRef, bookingId}, extraActions = []) => ({
    payload: {locationRef, bookingId, extraActions}
  })
});

export const MODALS = {
  MEMBER_CHECK_IN: 'memberCheckIn',
  ROOM_INSPECTION_PASS: 'roomInspectionPass',
  ROOM_INSPECTION_REMOVE: 'roomInspectionRemove',
  COMPLETE_ROOM_MOVE: 'completeRoomChange',
  PREVIEW_POID_DOCUMENT: 'previewPoidDocument',
  RENEW_BOOKING: 'renewBooking'
};

const initialState = {
  bookingBalances: []
};

const reducer = createReducer(initialState, {
  ...createFetchReducers(fetchRoomMoves),
  ...createFetchReducers(fetchCompletedRoomMoves),
  ...createFetchReducers(fetchPendingRenewals),
  ...createFetchReducers(fetchArrivals),
  ...createFetchReducers(fetchCheckedInTodayArrivals),
  ...createFetchReducers(fetchDepartures),
  ...createFetchReducers(fetchCheckedOutTodayDepartures),
  ...createFetchReducers(fetchCompletedRenewals)
});

export {default as frontDeskSaga} from './saga';

export default reducer;
